import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  Typography,
} from "@mui/material";
import { E2eTestSuiteResult } from "services/KnowfullyAdminClient";
import SuiteMiniStats from "./SuiteMiniStats";
import TestCaseRow from "./TestCaseRow";

type SuiteSectionProps = {
  suite: E2eTestSuiteResult;
};

const SuiteSection = ({ suite }: SuiteSectionProps) => {
  const failedCount = suite.cases?.filter((c) => c.status === "failed").length ?? 0;
  const skippedCount = suite.cases?.filter((c) => c.status === "skipped").length ?? 0;
  const defaultExpanded = failedCount > 0 || skippedCount > 0;

  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      elevation={0}
      sx={{
        "&:before": { display: "none" },
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        mb: 1,
        "&.Mui-expanded": { mb: 1 },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />} sx={{ minHeight: 36, py: 0 }}>
        <Typography variant="body2" fontWeight={500} sx={{ mr: 1 }}>
          {suite.title}
        </Typography>
        <SuiteMiniStats suite={suite} />
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Table size="small">
          <TableBody>
            {suite.cases?.map((testCase) => (
              <TestCaseRow key={testCase.title} testCase={testCase} />
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  );
};

export default SuiteSection;
